<template>
  <van-popup
    v-model="myVisible"
    closeable
    close-icon="close"
    position="bottom"
    safe-area-inset-bottom
    :style="{ height: `${height}%` }"
    @close="hidePopup"
  >
    <wh-map-draw
      v-if="myVisible"
      class="map-draw"
      :geometry-j-s-o-n="editGeometryData"
      style="height: 100%"
      :map-center="plotCenter"
      @change="mapDrawChange"
    />
  </van-popup>
</template>

<script>
import { popup } from '@/utils/mixins/popup'
import WhMapDraw from '@/components/public/WhMapDraw/WhMapDraw'
import { mapCenter } from '@/constant/common'

export default {
  name: 'MapDrawPopup',
  components: { WhMapDraw },
  mixins: [popup],
  props: {
    editGeometryData: {
      type: String,
      default: undefined
    }
  },
  computed: {
    plotCenter() {
      let plotCenter = mapCenter
      if (this.$store.getters.companyInfo.latLng) {
        const latLng = this.$store.getters.companyInfo.latLng.split(',')
        if (latLng && latLng.length === 2) {
          plotCenter = latLng
        }
      }
      return plotCenter
    }
  },
  methods: {
    mapDrawChange(mapDrawData) {
      this.$emit('change', mapDrawData)
      this.hidePopup()
    }
  }
}
</script>

<style lang='less' scoped>
.map-draw {
  /deep/ .search-box {
    width: 86%;
  }
}
</style>
